import { useState } from "react"
import MainContainer from "../common/MainContainer"
import UsersListing from "./UsersListing";
import useUser from "../../hooks/useUser";
import AddChip from "../common/ActionChip/AddChip";


export default function UsersManagement({ setBlockScreen }: any) {

  const [openActionModal, setOpenActionModal] = useState(false)
  const [action, setAction] = useState<'view' | 'edit' | 'create'>('view')
  const { userAdmin }: any = useUser()

  return (
    <>
      <MainContainer>
        {(userAdmin) && (
          <div className="users-actions-bar">
            <span className="users-actions-bar-add-btn">
              <AddChip
                label="Nuevo Usuario"
                onClick={() => { setAction('create'); setOpenActionModal(true) }}
              />
            </span>
          </div>
        )}

        <UsersListing
          openActionModal={openActionModal}
          setOpenActionModal={setOpenActionModal}
          action={action}
          setAction={setAction}
          canEdit={userAdmin}
          setBlockScreen={setBlockScreen} />

      </MainContainer>
    </>
  );
}
